/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface SenderSummary
 */
export interface SenderSummary {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    phone: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    note: string | null;
    /**
     * 
     */
    active: boolean;
    /**
     * 
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the SenderSummary interface.
 */
export function instanceOfSenderSummary(value: object): value is SenderSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    return true;
}

export function SenderSummaryFromJSON(json: any): SenderSummary {
    return SenderSummaryFromJSONTyped(json, false);
}

export function SenderSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SenderSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'phone': json['phone'],
        'name': json['name'],
        'note': json['note'],
        'active': json['active'],
        'createdAt': (json['created_at'] == null ? json['created_at'] : parseDateTime(json['created_at'])),
    };
}

export function SenderSummaryToJSON(json: any): SenderSummary {
    return SenderSummaryToJSONTyped(json, false);
}

export function SenderSummaryToJSONTyped(value?: SenderSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'phone': value['phone'],
        'name': value['name'],
        'note': value['note'],
        'active': value['active'],
        'created_at': value['createdAt'] == null ? value['createdAt'] : serializeDateTime(value['createdAt']),
    };
}

